import { X } from 'lucide-react';
import { Button } from './ui/button';

const STRIPE_LINKS = {
  monthly: 'https://buy.stripe.com/dRm5kE0BFag1fMR9SU3F604',
  targeting: 'https://buy.stripe.com/cNi5kE8472NzcAF7KM3F60b',
};

const PaywallPopup = ({ isOpen, onClose, type = 'subscription' }) => {
  if (!isOpen) return null;

  const handleUpgrade = () => {
    const link = type === 'targeting' ? STRIPE_LINKS.targeting : STRIPE_LINKS.monthly;
    window.location.href = link;
  };

  const content = {
    subscription: {
      title: '🚀 Upgrade zum vollen Zugriff',
      description: 'Sie haben Ihre kostenlose Nutzung aufgebraucht.',
      features: [
        '✅ Unbegrenzte Ad Copies',
        '✅ Unbegrenzte Bilder',
        '✅ Alle 22 Templates freigeschaltet',
        '✅ Download aller Creatives',
        '✅ Email-Support (48h)',
        '✅ Targeting Helper separat buchbar (59€)'
      ],
      price: '19,99€',
      period: 'pro Monat',
      cta: 'Jetzt für 19,99€/Monat upgraden'
    },
    targeting: {
      title: '🎯 Targeting Helper freischalten',
      description: 'Erhalten Sie Zugriff auf präzise Meta Ads Targeting-Empfehlungen.',
      features: [
        '✅ Detaillierte Interessen-Kategorien',
        '✅ Demografische Zielgruppen',
        '✅ Verhaltensbasiertes Targeting',
        '✅ Lookalike Audience Empfehlungen',
        '✅ Konkrete Anleitung für Meta Ads Manager'
      ],
      price: '59€',
      period: 'Einmalzahlung',
      cta: 'Targeting Helper für 59€ freischalten'
    }
  };

  const selectedContent = content[type];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl relative animate-in fade-in zoom-in duration-300">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>

        {/* Content */}
        <div className="p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            {selectedContent.title}
          </h2>
          <p className="text-gray-600 mb-6">
            {selectedContent.description}
          </p>

          {/* Features */}
          <div className="space-y-3 mb-6">
            {selectedContent.features.map((feature, index) => (
              <div key={index} className="flex items-start gap-2">
                <span className="text-green-600 mt-1">{feature.split(' ')[0]}</span>
                <span className="text-gray-700">{feature.substring(feature.indexOf(' ') + 1)}</span>
              </div>
            ))}
          </div>

          {/* Price */}
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-6 mb-6 text-center">
            <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
              {selectedContent.price}
            </div>
            <div className="text-gray-600 mt-1">
              {selectedContent.period}
            </div>
          </div>

          {/* CTA Button */}
          <Button
            onClick={handleUpgrade}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-6 text-lg font-bold rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
          >
            {selectedContent.cta} →
          </Button>

          <p className="text-xs text-gray-500 text-center mt-4">
            Jederzeit kündbar • Keine versteckten Kosten
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaywallPopup;
